import React from "react";
import { Facebook as LucideFacebook } from "lucide-react";

export interface SocialIconProps {
  size?: number | string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

// Google brand icon (multi-color)
export const GoogleBrandIcon: React.FC<SocialIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      onClick={onClick}
      aria-hidden
      focusable={false}
    >
      <path
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        fill="#4285F4"
      />
      <path
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        fill="#34A853"
      />
      <path
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        fill="#FBBC05"
      />
      <path
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        fill="#EA4335"
      />
    </svg>
  );
};

// Apple brand icon (wrapper - uses lucide Apple outline; can be swapped with filled path later)
export const AppleBrandIcon: React.FC<SocialIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      onClick={onClick}
      aria-hidden
      focusable={false}
    >
      <path
        d="M17.3689 14.2875C17.0916 14.928 16.7634 15.5176 16.3832 16.0596C15.8649 16.7986 15.4405 17.3101 15.1135 17.5942C14.6065 18.0604 14.0633 18.2992 13.4816 18.3128C13.0641 18.3128 12.5605 18.1939 11.9743 17.9529C11.3862 17.713 10.8457 17.5942 10.3515 17.5942C9.83319 17.5942 9.27733 17.713 8.68276 17.9529C8.08728 18.1939 7.60757 18.3196 7.24081 18.332C6.68302 18.3558 6.12704 18.1102 5.57207 17.5942C5.21787 17.2852 4.77483 16.7556 4.24408 16.0053C3.67464 15.2041 3.20647 14.275 2.8397 13.2158C2.44691 12.0717 2.25 10.9638 2.25 9.89123C2.25 8.6626 2.51549 7.60292 3.04725 6.71491C3.46517 6.00163 4.02115 5.43897 4.717 5.02592C5.41285 4.61286 6.16472 4.40238 6.97442 4.38891C7.41746 4.38891 7.99845 4.52595 8.72044 4.79529C9.4404 5.06552 9.90268 5.20257 10.1054 5.20257C10.2569 5.20257 10.7704 5.04233 11.641 4.72286C12.4643 4.42659 13.1591 4.30392 13.7283 4.35224C15.2708 4.47673 16.4296 5.08476 17.2002 6.1802C15.8208 7.01604 15.1384 8.18674 15.152 9.68855C15.1644 10.8583 15.5888 11.8318 16.4228 12.6047C16.8008 12.9634 17.2229 13.2407 17.6925 13.4376C17.5907 13.733 17.4832 14.0159 17.3689 14.2875ZM13.8313 0.367015C13.8313 1.28389 13.4963 2.13998 12.8287 2.93236C12.0229 3.87435 11.0484 4.41867 9.99151 4.33278C9.97804 4.22278 9.97024 4.10701 9.97024 3.98536C9.97024 3.10516 10.3534 2.16317 11.0339 1.39297C11.3736 1.003 11.8057 0.678752 12.3296 0.420089C12.8524 0.165286 13.347 0.0243746 13.8121 0.000244141C13.8257 0.122816 13.8313 0.245396 13.8313 0.367003V0.367015Z"
        fill="black"
      />
    </svg>
  );
};

// Facebook brand icon (wrapper - uses lucide Facebook; brand blue via className if istenirse)
export const FacebookBrandIcon: React.FC<SocialIconProps> = ({
  size = 24,
  className = "",
  style,
  onClick,
}) => {
  return (
    <LucideFacebook
      width={Number(size)}
      height={Number(size)}
      className={className}
      style={style}
      onClick={onClick}
      aria-hidden
    />
  );
};

export default GoogleBrandIcon;
